import { API_ENDPOINT } from './config';

export const urlsFriOpen = {
  foEvents: `${API_ENDPOINT}/fo-events`,
  foNonArchivedEvents: `${API_ENDPOINT}/fo-events/active`,
  foArchivedEvents: `${API_ENDPOINT}/fo-events/archived`,
  foEventArchivation: (id) => `${API_ENDPOINT}/fo-events/archived/${id}`,
  foEventRestoreCopy: (id) => `${API_ENDPOINT}/fo-events/archived/${id}/restore-copy`,
  foEventDetail: (id) => `${API_ENDPOINT}/fo-events/${id}`,
  foEventDates: (id) => `${API_ENDPOINT}/fo-events/${id}/dates`,
  foWorkshops: (id) => `${API_ENDPOINT}/fo-events/${id}/workshops`,
  foWorkshopsStore: `${API_ENDPOINT}/fo-workshops`,
  foWorkshopDetail: (id) => `${API_ENDPOINT}/fo-workshops/${id}`,
  foAllWorkshops: `${API_ENDPOINT}/fo-workshops/all`,
  foRegistration: `${API_ENDPOINT}/fo-dates/registration`,
  foDates: (id) => `${API_ENDPOINT}/fo-workshops/${id}/dates`,
  foMyDates: `${API_ENDPOINT}/fo-dates/my`,
  foDatesStore: `${API_ENDPOINT}/fo-dates`,
  foDateDetail: (id) => `${API_ENDPOINT}/fo-dates/${id}`,
  foDateToggleEnabled: (id) => `${API_ENDPOINT}/fo-dates/${id}/toggle-enabled`,
  foDateParticipants: (id) => `${API_ENDPOINT}/fo-dates/${id}/participants`,
  foAllDates: `${API_ENDPOINT}/fo-dates/all`,
  foDatesCollisions: `${API_ENDPOINT}/fo-dates/collisions`,
  foMyDatesCollisions: `${API_ENDPOINT}/fo-dates/my-collisions`,
};

export const routesFriOpen = {
  // Public
  friOpenEventsList: '/fri-open',
  friOpenEventsDetail: (eventId) => `/fri-open/event/${eventId}`,
  friOpenWorkshopsDetail: (workshopId) => `/fri-open/workshops/${workshopId}`,
  friOpenDatesDetail: (dateId) => `/fri-open/dates/${dateId}`,
  friOpenRegistration: '/fri-open/registration',

  // CMS
  cmsFoEventsList: '/cms/fri-open/events',
  cmsFoEventsDetail: (eventId) => `/cms/fri-open/events/${eventId}`,
  cmsFoEventsUnarchive: (eventId) =>
    `/cms/fri-open/events/unarchiving/${eventId}`,
  cmsFoEventsEdit: (eventId) => `/cms/fri-open/events/edit/${eventId}`,
  cmsFoEventsCreate: '/cms/fri-open/events/create',

  cmsFoWorkshopsList: (eventId) => `/cms/fri-open/events/${eventId}/workshops`,
  cmsFoWorkshopsDetail: (workshopId) => `/cms/fri-open/workshops/${workshopId}`,
  cmsFoWorkshopsEdit: (workshopId) =>
    `/cms/fri-open/workshops/edit/${workshopId}`,
  cmsFoWorkshopsCreate: (eventId) =>
    `/cms/fri-open/events/${eventId}/workshops/create`,

  cmsFoDatesList: (workshopId) => `/cms/fri-open/workshops/${workshopId}/dates`,
  cmsFoMyDatesList: `/cms/fri-open/my-dates`,
  cmsFoDatesEdit: (dateId) => `/cms/fri-open/dates/edit/${dateId}`,
  cmsFoDatesDetail: (dateId) => `/cms/fri-open/dates/${dateId}`,
  cmsFoDateParticipants: (dateId) =>
    `/cms/fri-open/dates/participants/${dateId}`,
  cmsFoDatesCreate: (workshopId) =>
    `/cms/fri-open/workshops/${workshopId}/dates/create`,
};
